// Date 객체를 HH:mm 형식의 시간 문자열로 변환
// ex) new Date("2024-01-01T09:30:00") -> "09:30"
export const setDefaultDate = (date) => {
    const d = date instanceof Date ? date : new Date(date); // 문자열도 처리
    if (isNaN(d.getTime())) {
        console.warn(`setDefaultDate: 유효하지 않은 날짜 값 - ${date}`);
        return '';
    }
    return d.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit', hour12: false });
}

// HH:mm 형식의 시간 문자열을 현재 날짜 기준 ISO 8601 형식으로 변환
// ex) "09:30" -> "2024-01-01T00:30:00.000Z"
export const getIsoDateTime = (timeStr) => {
    const now = new Date();
    const [hours, minutes] = timeStr.split(':').map(Number);
    now.setHours(hours, minutes, 0, 0);
    return now.toISOString();
};

// UTC 날짜 문자열을 로컬 시간으로 변환
export const utcToLocal = (utcDateStr) => {
    if (!utcDateStr) {
        console.warn("utcToLocal: 날짜 값이 없습니다.");
        return null;
    }

    const utcDate = new Date(utcDateStr);

    if (isNaN(utcDate.getTime())) {
        console.warn(`utcToLocal: 유효하지 않은 날짜 값 - ${utcDateStr}`);
        return null;
    }

    // 로컬 타임존 오프셋(분)을 밀리초로 변환하여 UTC 시간에서 차감
    const localDate = new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60000));
    return localDate.toISOString();
};

// utils/Date.js에 추가
// 주어진 시간 문자열 또는 Date 객체의 "오늘 자정부터 경과한 밀리초"를 계산
// 날짜는 무시하고 HH:mm:ss만 사용
export const getTimeOfDayInMs = (timeInput) => {
    const d = timeInput instanceof Date ? timeInput : new Date(timeInput);
    return d.getHours() * 3600000 + d.getMinutes() * 60000 + d.getSeconds() * 1000;
};

// utils/Date.js에 추가
// 스케줄의 시작시간, 종료시간, 활성 피드, 총 시간을 계산
export const getScheduleMetrics = (schedule) => {
    const scheduleMs = getTimeOfDayInMs(schedule.SCHEDULE_TIME);

    let feedSet = [];
    try {
        feedSet = JSON.parse(schedule.RESERVATION_DATA).feed_set;
    } catch (error) {
        console.error('RESERVATION_DATA 파싱 오류:', error);
    }

    const activeFeeds = feedSet.filter(feed => feed.active === 1);
    const totalDurationMs = activeFeeds.reduce((sum, feed) => sum + feed.time * 100, 0);
    const endTimeMs = scheduleMs + totalDurationMs;

    return { scheduleMs, totalDurationMs, activeFeeds, endTimeMs };
};